import { render, staticRenderFns } from "./LcSummarySubItem.vue?vue&type=template&id=22be6672&scoped=true"
import script from "./LcSummarySubItem.vue?vue&type=script&lang=js"
export * from "./LcSummarySubItem.vue?vue&type=script&lang=js"
import style0 from "./LcSummarySubItem.vue?vue&type=style&index=0&id=22be6672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be6672",
  null
  
)

export default component.exports